import React from 'react';
import { motion } from 'framer-motion';
import { Activity, Shield, Sparkles } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import styles from './About.module.css';

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.02,
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 10 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.2 },
  },
};

export const About: React.FC = () => {
  const { t } = useLanguage();

  return (
    <section className={styles.about} id="about">
      <div className={styles.about__container}>
        <motion.div
          className={styles.about__grid}
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: '-100px' }}
        >
          <div className={styles.about__imageWrapper}>
            <picture>
              <img
                className={styles.about__image}
                src="/images/team_collaboration_v2.png"
                alt="Strategic consulting team meeting"
                loading="lazy"
              />
            </picture>
          </div>

          <div className={styles.about__content}>
            <motion.span
              className={styles.about__tag}
              variants={itemVariants}
            >
              <Sparkles size={14} />{t.about.tag}
            </motion.span>

            <motion.h2 className={styles.about__title} variants={itemVariants}>
              {t.about.title}{' '}
              <span className={styles.about__titleHighlight}>
                {t.about.titleHighlight}
              </span>
            </motion.h2>

            <motion.p
              className={styles.about__description}
              variants={itemVariants}
            >
              {t.about.description1}
            </motion.p>

            <motion.p
              className={styles.about__description}
              variants={itemVariants}
            >
              {t.about.description2}
            </motion.p>

            <div className={styles.about__cards}>
              <motion.div
                className={styles.about__card}
                variants={itemVariants}
                whileHover={{ y: -5, transition: { duration: 0.2 } }}
              >
                <div className={styles.about__cardIcon}>
                  <Activity size={28} />
                </div>
                <h3 className={styles.about__cardTitle}>{t.about.card1Title}</h3>
                <p className={styles.about__cardText}>{t.about.card1Text}</p>
              </motion.div>

              <motion.div
                className={styles.about__card}
                variants={itemVariants}
                whileHover={{ y: -5, transition: { duration: 0.2 } }}
              >
                <div className={styles.about__cardIcon}>
                  <Shield size={28} />
                </div>
                <h3 className={styles.about__cardTitle}>{t.about.card2Title}</h3>
                <p className={styles.about__cardText}>{t.about.card2Text}</p>
              </motion.div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default About;
